// ============================================================================
// CASE COURT DETAIL HOOK — ADR-0001
// ============================================================================

import { useState, useEffect, useCallback } from 'react';
import { caseCourtDetailService } from '../../api/services/caseCourtDetailService';
import type { CaseCourtDetail } from '../../api/types/caseCourtDetail.types';
import type { ID } from '../../api/types';

export const useCaseCourtDetail = (caseId: ID | undefined) => {
  const [data, setData] = useState<CaseCourtDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!caseId) { setData(null); return; }
    setLoading(true); setError(null);
    try {
      const response = await caseCourtDetailService.getByCase(caseId);
      setData(response.data ?? null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [caseId]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
